/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
import { userDetail } from '@/api/ajax';
import router from '@/router/index';
import store from '@/store';

export const setStorage = function(key, val) {
  //设置缓存
  let values = val;
  if (typeof val == 'object') {
    values = JSON.stringify(val);
  }
  localStorage.setItem(key, values);
};

export const getStorage = function(key) {
  //获取缓存
  if (!localStorage[key]) {
    return null;
  } else {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }
};

/**
 * @description: 获取当前专区下用户信息
 * @param { string } afferentName 传入专区缓存key，不是必须。
 *                                拦截器中，第一次调用时，router在这里没有参数
 * @return { object }
 */
export const storageUserInfo = function(afferentName) {
  const channelNo = router.currentRoute.params.channelNo;
  const storageName = afferentName || 'channel' + channelNo;
  const userInfo =  getStorage(storageName) || {};
  store.commit('user/SET_INFO', userInfo);
  return userInfo
};
// 同步当前用户信息并返回
export const syncUserInfo = async function(data) {
  const channelNo = router.currentRoute.params.channelNo;
  let userInfo = data;
  if (!userInfo) {
    let {
      data: { data: info }
    } = await userDetail();
    userInfo = info;
  }
  let storageName = 'channel' + channelNo;
  setStorage(storageName, userInfo);
  store.commit('user/SET_INFO', userInfo);
  return Promise.resolve(userInfo);
};

// 设置跳往注册前的URL
export const setBeforeRegisterUrl = url => {
  url = url || window.location.href;
  if (!['sms', 'word', 'perfect', 'register'].includes(url)) {
    sessionStorage.setItem('beforeRegisterUrl', url);
  }
};
// 注册后回跳使用
export const jumpBeforeRegisterUrl = () => {
  let beforeRegisterUrl = sessionStorage.beforeRegisterUrl;
  if (beforeRegisterUrl) {
    sessionStorage.removeItem('beforeRegisterUrl');
    window.location.href = beforeRegisterUrl;
  }
  return beforeRegisterUrl;
};
